import { create } from 'zustand';
import { MapLayerStore } from '../types/map';

export const useMapLayerStore = create<MapLayerStore>((set) => ({
  globalShapeFile: [],
  datasetZones: [],
  fweModelDomains: [],
  selectedPolygonLayer: [],
  surfaceMapLayerData: [],

  setGlobalShapeFile: (data) => set({ globalShapeFile: data }),
  setDatasetZones: (data) => set({ datasetZones: data }),
  setFWEModelDomains: (data) => set({ fweModelDomains: data }),
  setSurfaceMapLayerData: (data) => set({ surfaceMapLayerData: data }),
}));
